import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { Catalog } from '../../interfaces/entity-interfaces';
import { Entity } from '../../services/entity.service';
import { CatalogActions, setCatalog, setCatalogs } from './catalog.actions';

@Injectable()
export class CatalogEffects {
    private actions$ = inject(Actions);
    private store = inject(Store);
    private Entity = inject(Entity);

    loadCatalogs$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CatalogActions.LoadCatalogs),
                tap(() => {
                    this.Entity.get('catalog')
                        .search({})
                        .then((payload: Catalog[]) => {
                            this.store.dispatch(setCatalogs({ payload }));
                        });
                })
            ),
        { dispatch: false }
    );

    loadCatalog$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CatalogActions.LoadCatalog),
                tap((action: { payload: { id: number } }) => {
                    this.Entity.get('catalog')
                        .get({ id: action.payload.id, join: ['pages', 'coverImage', 'publicLink'] })
                        .then((payload: Catalog) => {
                            this.store.dispatch(setCatalog({ payload }));
                        });
                })
            ),
        { dispatch: false }
    );
}
